export default "__VITE_ASSET__05e3da9c__"